import { render, staticRenderFns } from "./word.vue?vue&type=template&id=6a6c0abd&"
import script from "./word.vue?vue&type=script&lang=ts&"
export * from "./word.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports